import { Injectable } from '@angular/core';
import { AResourceService } from './a-resource.service';
import { VehicleModel } from '../../models/resources/vehicle.model';

@Injectable({
  providedIn: 'root',
})
export class VehicleService extends AResourceService<VehicleModel> {
  constructor() {
    super('/vehicles', true, [
      'location',
      'vitabeneEmployee'
    ]);
  }

  // removeLocationId() {
  //   this.setResourceUrl(`/vehicles`);
  // }
}
